import { type ChangeEvent, type FC, useCallback, useId } from "react";
import { LinkGen } from "../LinkGen";
import "./CompanySelector.style.css";
import { useNavigate } from "react-router-dom";
import { useProfile } from "../auth/useProfile";
import { Icon } from "../common/Icon";
import { Select } from "../components/Select";
import { useCompanies, useCompany } from "./useCompany";
import { useSelectedCompany } from "./useSelectedCompany";

export const CompanySelector: FC = () => {
	const id = useId();
	useProfile(); // Fixes issue when queries dependant on profile are called
	const companies = useCompanies();
	const company = useCompany();
	const [_, setSelected] = useSelectedCompany();

	const navigate = useNavigate();

	const handleChange = useCallback(
		async (e: ChangeEvent<HTMLSelectElement>) => {
			const companyId = Number(e.target.value);
			setSelected(companyId);
			navigate(LinkGen.Dashboard());
		},
		[setSelected, navigate],
	);

	if (!companies || companies.length < 2) {
		return null;
	}

	return (
		<li>
			<Select
				className="company-selector"
				value={company.id}
				onChange={handleChange}
				id={`company-selector-${id}`}
				aria-label="Select company"
				trigger={
					<>
						<Icon
							className="company-selector-icon"
							name="account_circle"
							size={24}
						/>
						<span className="company-selector-value">
							{company.name || <i>Unnamed company</i>}
						</span>
					</>
				}
			>
				{companies.map(({ id: companyId, name }) => {
					return (
						<option key={companyId} value={companyId}>
							{name || "Unnamed company"}
						</option>
					);
				})}
			</Select>
		</li>
	);
};
